import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";
import { NotifyService } from "../services/notify-service";
import { EntityConfigService } from "../services/entity-config-service";
import { EntityService } from "../services/entity-service";
import { EventService } from "../services/event-service";
import { AclService } from "../services/acl-service";
import { ModalService } from "../services/modal-service";
import { WorkflowService } from "../services/workflow-service";

RLCopyEntity.$inject = ["$document", "$compile"];
export function RLCopyEntity($document: ng.IDocumentService, $compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/copy-entity.html"),
        controller: RLCopyEntityController,
        controllerAs: "cpVM",
        bindToController: true,
        scope: {
            smallButton: "@",
            parentEntityID: "=?parentEntityId",
            entity: "=originalEntity",
            originalEntityId: "=?",
            successCallback: "&",
            forceRelCopy: "=",
            entityNoun: "@?",
            locked: "=",
            show: "=",
            appendToBody: '@?',
            parentRelEntityID: "=?parentRelEntityId"
        },
        priority: -1,
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var appendToBody = angular.isDefined(attributes["appendToBody"]);

            if (appendToBody) {
                var form = element[0].children[1];
                angular.element(form).remove();

                $compile(form)(scope);
                $document.find('body').append(form);
            }
        }
    };

    return directive;
}

class RLCopyEntityController {
    public static $inject = [
        "$scope",
        "$q",
        "$window",
        "$filter",
        "notifyService",
        "entityConfigService",
        "entityService",
        "eventService",
        "aclService",
        "modalService",
        "workflowService"
    ];

    smallButton: boolean = false;
    parentEntityID: string;
    entity: Models.IEntity;
    originalEntity: Models.IEntity;
    successCallback: any; //initialize to function def?
    forceRelCopy: boolean;
    locked: boolean;
    show: boolean;
    parentRelEntityID: string;

    entityNoun: string = "";
    selectedCharTypeID: any = 0;
    selectedMigrateToCharTypeID: number;
    selectedTemplateID: number = 0;
    selectedCopyToCharTypeID: number;
    selectedCopyToTemplateID: number;
    copyModalOpen: boolean = false;
    copyRelationships: boolean = true;
    templates: Models.ICharacteristicTemplate[];
    copyToTemplates: Models.ICharacteristicTemplate[];
    copyToCharTypes: Models.ICharacteristicType[] = [];
    migrateToCharTypes: Models.ICharacteristicType[] = [];
    initialized: boolean = false;
    isOldVersion: boolean = false;
    canWriteOriginalTemplate: boolean;
    canCreateOriginalTemplate: boolean;

    showCopyParties: boolean;
    copyParties: boolean = true;
    newTitle: string;
    maxTitleChars: number;
    copyType: number = 1;
    selectAssociations: boolean = false;
    showCopyMigrateCharTypeSelector: boolean = true;

    invalidFields: string;
    invalidPartiesContacts: string;
    invalidAssociations: string;
    lockedAssociations: string;

    originalEntityId: string;
    moduleLevelCharTypeIDs: { [id: string]: number } = Consts.ModuleLevelCharTypes.IDs;

    public constructor(private $scope: ng.IScope,
        private readonly $q: ng.IQService,
        private readonly $window: ng.IWindowService,
        private readonly $filter: ng.IFilterService,
        private readonly notifyService: NotifyService,
        private readonly entityConfigService: EntityConfigService,
        private readonly entityService: EntityService,
        private readonly eventService: EventService,
        private readonly aclService: AclService,
        private readonly modalService: ModalService,
        private readonly workflowService: WorkflowService) {
        this.maxTitleChars = 0;
    }

    $onInit() {
        this.$scope.$watch(() => this.entity, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.originalEntity = newValue;
            }
        });

        this.$scope.$watch(() => this.originalEntity,
            (newValue, oldValue) => {
                if (this.originalEntity != null && (newValue != oldValue || this.copyToCharTypes.length == 0)) {
                    this.LoadCharTypes().then(() => {

                        if (!Utils.CharUtil.IsModuleLevelCharType(this.originalEntity.charTypeID)) {
                            this.showCopyMigrateCharTypeSelector = false;
                        }

                        this.isOldVersion = this.originalEntity.charTypeID == Consts.CharTypeIDs.usage || this.originalEntity.charTypeID == Consts.CharTypeIDs.amount;
                        this.canWriteOriginalTemplate = this.CanWriteOriginalTemplate();
                        this.canCreateOriginalTemplate = this.CanCreateOriginalTemplate();

                        if (this.isOldVersion || (!this.canCreateOriginalTemplate && this.copyToCharTypes.length > 0)) {
                            this.copyType = 3;
                        } else if (!this.isOldVersion && !this.canCreateOriginalTemplate && this.canWriteOriginalTemplate && this.migrateToCharTypes.length > 0) {
                            this.copyType = 2;
                        }

                        this.showCopyParties = this.copyParties = this.originalEntity.charTypeID == Consts.CharTypeIDs.user ? false : true;
                        this.newTitle = "NEW -- " + this.originalEntity.title;
                        this.selectedCharTypeID = this.originalEntity.charTypeID;
                        this.selectedCopyToCharTypeID = this.originalEntity.charTypeID;
                        this.selectedCopyToTemplateID = this.originalEntity.templateID;
                        this.selectedMigrateToCharTypeID = this.originalEntity.charTypeID;
                        this.SetTitleMax(this.originalEntity.charTypeID, this.originalEntity.templateID);
                    });
                }
            }, true);

        this.$scope.$watch(() => this.selectedMigrateToCharTypeID,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    //Update the templates for the chartype
                    var parentCharType = this.parentEntityID ? Utils.IdBuilder.splitEntityID(this.parentEntityID).charTypeID : null;
                    this.LoadMigrateTemplates(newValue, -1, parentCharType);
                }
            });

        this.$scope.$watch(() => this.selectedTemplateID,
            (newValue, oldValue) => {
                if (newValue > 0 && this.originalEntity != null && this.selectedTemplateID != this.originalEntity.templateID) {
                    this.PerformWarningCheck();
                } else {
                    this.invalidFields = "";
                    this.invalidPartiesContacts = "";
                    this.invalidAssociations = "";
                }
            });

        this.$scope.$watch(() => this.selectedCopyToCharTypeID,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    //Update the templates for the chartype
                    this.LoadCopyTemplates(newValue, -1);
                }
            });

        this.$scope.$watch(() => this.selectedCopyToTemplateID,
            (newValue, oldValue) => {
                if (newValue > 0 && this.originalEntity != null && this.selectedCopyToTemplateID != this.originalEntity.templateID) {
                    this.PerformWarningCheck();
                } else {
                    this.invalidFields = "";
                    this.invalidPartiesContacts = "";
                    this.invalidAssociations = "";
                }
            });

        this.$scope.$watch(() => this.copyToTemplates,
            (newValue, oldValue) => {
                if (newValue != oldValue && newValue.length > 0) {
                    this.selectedCopyToTemplateID = _.find(newValue, (v) => v.templateID === this.originalEntity.templateID) ? this.originalEntity.templateID : newValue[0].templateID;
                }
            });

        this.$scope.$watch(() => this.copyType,
            (newValue, oldValue) => {
                if (this.originalEntity != null) {
                    //Reset the dropdowns
                    this.selectedCopyToCharTypeID = this.originalEntity.charTypeID;
                    this.selectedMigrateToCharTypeID = this.originalEntity.charTypeID;
                    this.selectedTemplateID = _.any(this.templates) ? this.templates[0].templateID : null;
                    this.selectedCopyToTemplateID = _.any(this.copyToTemplates) ? this.copyToTemplates[0].templateID : null;

                    if (this.forceRelCopy && this.copyType == 1) {
                        this.newTitle = "NEW -- " + this.originalEntity.title;
                    }
                    else if (this.forceRelCopy && this.copyType == 3) {
                        this.newTitle = "COPY -- " + this.originalEntity.title;
                    }
                    else if (this.forceRelCopy && this.copyType == 2) {
                        this.newTitle = this.originalEntity.title;
                    }
                }
            });
    }

    LoadCharTypes(): ng.IPromise<any> {
        this.notifyService.startProgress();

        return this.aclService.loadActivityAcls()
            .then((acls) => {
                var aclOriginalEntityString = "acl://activity/site/mod" + this.originalEntity.charTypeID;
                var canEditOriginalEntity = Utils.AclUtil.hasWriteAccess(acls, aclOriginalEntityString);

                return this.entityConfigService.getCharacteristicTypes()
                    .then((charTypes) => {
                        var moduleCharTypes = charTypes.filter(c => Utils.CharUtil.IsModuleLevelCharType(c.charTypeID));

                        _.forEach(moduleCharTypes, (moduleCharType) => {
                            var aclString = "acl://activity/site/mod" + moduleCharType.charTypeID;
                            var canCreate = Utils.AclUtil.hasCreateAccess(acls, aclString);
                            var charName = moduleCharType.charTypeName;

                            if (charName == "Transaction") {
                                charName = "Deals";
                            } else if (charName == "Work Orders") {
                                charName = "Jobs";
                            } else if (charName == "Property") {
                                charName = "Catalog Items";
                            } else if (charName == "Invoice") {
                                charName = "Accounting";
                            }

                            if (canCreate) {
                                this.copyToCharTypes.push({
                                    charTypeID: moduleCharType.charTypeID,
                                    charTypeName: charName,
                                    seqNumber: 0 //We don't care about the sequence number
                                });
                            }

                            if ((canEditOriginalEntity && canCreate) || (canEditOriginalEntity && moduleCharType.charTypeID == this.originalEntity.charTypeID)) {
                                this.migrateToCharTypes.push({
                                    charTypeID: moduleCharType.charTypeID,
                                    charTypeName: charName,
                                    seqNumber: 0 //We don't care about the sequence number
                                });
                            }
                        });
                    });
            })
            .finally(() => {
                //Sort the rows by modules, then by components
                var sortList = [2, 16, 1, 4, 17, 15, 7]
                var sortedCopyTo = _.sortBy(this.copyToCharTypes, function (obj) {
                    return _.indexOf(sortList, obj.charTypeID);
                });

                var sortedMigrateTo = _.sortBy(this.migrateToCharTypes, function (obj) {
                    return _.indexOf(sortList, obj.charTypeID);
                });

                this.copyToCharTypes = [];
                this.copyToCharTypes = sortedCopyTo;
                this.migrateToCharTypes = sortedMigrateTo;
                this.notifyService.endProgress();
            });
    }

    CanCreateOriginalTemplate() {
        var aclOriginalEntityString = `acl://data/entities/ct_${this.originalEntity.charTypeID}/tg_${this.originalEntity.templateGroupID}/tm_${this.originalEntity.templateID}`;
        return Utils.AclUtil.hasCreateAccess(this.aclService.acls, aclOriginalEntityString);
    }

    CanWriteOriginalTemplate() {
        var aclOriginalEntityString = `acl://data/entities/ct_${this.originalEntity.charTypeID}/tg_${this.originalEntity.templateGroupID}/tm_${this.originalEntity.templateID}`;
        return Utils.AclUtil.hasWriteAccess(this.aclService.acls, aclOriginalEntityString);
    }

    LoadCopyTemplates(charTypeID: number, templateID: number, parentCharTypeID?: number, isRelationshipType?: boolean): ng.IPromise<any> {
        if (Utils.CharUtil.IsModuleLevelCharType(charTypeID)) {
            return this.entityConfigService.getCharacteristicTemplates(charTypeID)
                .then((results) => {
                    this.copyToTemplates = results.filter(t => Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                    this.initialized = true;
                });
        } else if (isRelationshipType) {
            return this.entityService.getAssociatedTemplatesForTemplate(parentCharTypeID, templateID, charTypeID)
                .then((results) => {
                    this.copyToTemplates = results.filter(t => t.templateGroupID == Consts.TemplateGroupIDs.DealCatalogLevelUsageTemplateGroup && Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                    this.initialized = true;
                });
        } else if (parentCharTypeID) {
            return this.entityService.getAssociatedTemplatesForTemplate(parentCharTypeID, templateID, charTypeID)
                .then((results) => {
                    if (charTypeID == Consts.CharTypeIDs.usage) {
                        this.copyToTemplates = results.filter(t => t.templateGroupID != Consts.TemplateGroupIDs.DealCatalogLevelUsageTemplateGroup && Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                    }
                    else { // template group filters only needed for usages
                        this.copyToTemplates = results.filter(t => Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                    }

                    this.initialized = true;
                });
        } else {
            this.initialized = true;
        }
    }

    LoadMigrateTemplates(charTypeID: number, templateID: number, parentCharTypeID?: number, isRelationshipType?: boolean): ng.IPromise<any> {
        if (Utils.CharUtil.IsModuleLevelCharType(charTypeID)) {
            return this.entityConfigService.getCharacteristicTemplates(charTypeID)
                .then((results) => {
                    this.templates = results.filter(t => t.templateID != this.originalEntity.templateID && Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                    this.initialized = true;
                });
        } else if (isRelationshipType) {
            return this.entityService.getAssociatedTemplatesForTemplate(parentCharTypeID, templateID, charTypeID)
                .then((results) => {
                    this.templates = results.filter(t => t.templateID != this.originalEntity.templateID && t.templateGroupID == Consts.TemplateGroupIDs.DealCatalogLevelUsageTemplateGroup && Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                    this.initialized = true;
                });
        } else if (parentCharTypeID) {
            return this.entityService.getAssociatedTemplatesForTemplate(parentCharTypeID, templateID, charTypeID)
                .then((results) => {
                    if (charTypeID == Consts.CharTypeIDs.usage) {
                        this.templates = results.filter(t => t.templateID != this.originalEntity.templateID && t.templateGroupID != Consts.TemplateGroupIDs.DealCatalogLevelUsageTemplateGroup && Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                    }
                    else { // template group filters only needed for usages
                        this.templates = results.filter(t => t.templateID != this.originalEntity.templateID && Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                    }

                    this.initialized = true;
                });
        } else {
            return this.$q.when(null);
        }
    }

    OpenCopyModal() {
        var promise: ng.IPromise<void>;
        if (this.originalEntity) {
            //Refresh the to be copied entity prior to opening the modal so the data being pulled is the most up to date
            promise = this.entityService.getEntity(this.originalEntity.id)
                .then((result) => {
                    this.originalEntity = result.record;
                    this.copyModalOpen = true;
                });
        } else if (this.originalEntityId) {
            promise = this.entityService.getEntity(this.originalEntityId)
                .then((result) => {
                    this.originalEntity = result.record;
                    this.selectedCopyToCharTypeID = result.record.charTypeID;
                    this.selectedCopyToTemplateID = result.record.templateID;
                    this.selectedCharTypeID = result.record.charTypeID;
                });
        }

        promise.then(() => {
            if (this.originalEntity.charTypeID == Consts.CharTypeIDs.right) {
                //Check to see if the entity tied to the right set is locked
                this.IsRightSetLocked();
            }

            if (this.selectedCharTypeID > 0 && (!this.copyToTemplates || this.copyToTemplates.length == 0)) {
                this.initialized = false;

                var charType = this.selectedCharTypeID;
                var templateID = this.originalEntity.templateID;

                if (this.parentEntityID != null) {
                    var isRelationshipType = false;
                    var parentEntityID = this.parentEntityID;
                    var parentCharType = Utils.IdBuilder.splitEntityID(parentEntityID).charTypeID;

                    //If the parent entity is a relationship, we need to check the parent rel entity id as that should contain the main
                    //parent.
                    if (parentCharType == Consts.CharTypeIDs.relationship) {
                        parentEntityID = this.parentRelEntityID;
                        isRelationshipType = true;
                        parentCharType = Utils.IdBuilder.splitEntityID(parentEntityID).charTypeID;
                    }

                    this.entityService.getEntityRecord(parentEntityID)
                        .then((result) => {
                            var parentTemplateID = result.templateID;

                            this.LoadCopyTemplates(charType, parentTemplateID, parentCharType, isRelationshipType);
                            this.LoadMigrateTemplates(charType, parentTemplateID, parentCharType);
                            this.copyModalOpen = true;
                        })
                } else {
                    this.LoadCopyTemplates(charType, templateID);
                    this.copyModalOpen = true;
                }
            }
        });
    }

    IsRightSetLocked() {
        var count: number = 0;
        this.lockedAssociations = "";

        this.entityService.getEntityParentRelationship(this.originalEntity.id, Consts.CharTypeIDs.property)
            .then((results) => {
                _.forEach(results, result => {
                    var parentEntity = Utils.IdBuilder.buildEntityID(result.divisionID, result.parentCharTypeID, result.parentRecID);

                    this.entityService.getEntityStatus(parentEntity)
                        .then((entityStatus) => {
                            this.entityService.getEntityRecord(parentEntity)
                                .then((entityRecord) => {
                                    if (entityStatus.lockIndicator > 0) {
                                        //The record is locked
                                        if (count > 0) {
                                            this.lockedAssociations += "; ";
                                        }

                                        this.lockedAssociations += entityRecord.title;

                                        count = count + 1;
                                    }
                                })
                        });
                });
            })
            .finally(() => {
                this.lockedAssociations = this.lockedAssociations.trim();
            });
    }

    SetTitleMax(charTypeID: number, templateID: number) {
        this.entityService.getEmptyEntityCharData(Utils.IdBuilder.buildTemplateID(this.originalEntity.divisionID, charTypeID, templateID)).then((templateResult) => {
            var titleCmd = _.find(templateResult.templateMetaData.characteristicMetaDatas, (cd) => cd.tagLabel == "entity_title");
            if (titleCmd) {
                this.maxTitleChars = titleCmd.maxLength;
                this.newTitle = this.newTitle.substr(0, titleCmd.maxLength - 1);
            }
        });
    }

    PerformWarningCheck() {
        //Do the checks for the delta values that will be deleted
        var newCharTypeID = this.originalEntity.charTypeID;
        var newTemplateID = this.originalEntity.templateID;

        if (this.copyType == 2) {
            newCharTypeID = this.selectedMigrateToCharTypeID;
            newTemplateID = this.selectedTemplateID;
        } else if (this.copyType == 3) {
            newCharTypeID = this.selectedCopyToCharTypeID;
            newTemplateID = this.selectedCopyToTemplateID;
        }

        //Check for any deleted characteristics
        this.invalidFields = "";
        this.SetTitleMax(newCharTypeID, newTemplateID);

        this.entityService.updateEntityTemplateEntityCheck(true, this.originalEntity.id, this.originalEntity.charTypeID, this.newTitle, newCharTypeID, newTemplateID, this.copyParties, this.selectAssociations)
            .then((result) => {
                var deletedCharacteristics = result.data;

                var count: number = 0;

                this.invalidFields = "";
                _.forEach(deletedCharacteristics, (dc: Models.IUpdateEntityTemplateEntityCheck) => {
                    this.entityConfigService.getCharacteristic(this.originalEntity.charTypeID, dc.charID)
                        .then((characteristic) => {
                            if (count > 0) {
                                this.invalidFields += "; ";
                            }

                            this.invalidFields += characteristic.label;
                        })
                        .finally(() => {
                            count = count + 1;
                        });
                });
            })
            .finally(() => {
                this.invalidFields = this.invalidFields.trim();
            });

        //Check for any deleted relationships (this includes Contacts)
        var relTemplates: string[] = [];
        this.invalidPartiesContacts = "";

        this.entityService.updateEntityTemplateRelationshipsCheck(true, this.originalEntity.id, this.originalEntity.charTypeID, this.newTitle, newCharTypeID, newTemplateID, this.copyParties, this.selectAssociations)
            .then((result) => {
                var deletedRelationships = result.data;
                var contactCount: number = 0;

                _.forEach(deletedRelationships, (dr: Models.IUpdateEntityTemplateRelationshipsCheck) => {
                    if (dr.childCharTypeID == Consts.CharTypeIDs.user) {
                        this.entityConfigService.getTemplateParties(this.originalEntity.charTypeID, this.originalEntity.templateID)
                            .then((parties) => {
                                if (contactCount > 0) {
                                    this.invalidPartiesContacts += "; ";
                                }

                                var party = _.find(parties, p => p.partyID == dr.relRecIndicatorID);

                                if (party) {
                                    var partyName = party.partyName;
                                    this.invalidPartiesContacts += partyName;
                                }
                            })
                            .finally(() => {
                                contactCount = contactCount + 1;
                            });
                    }
                    else {
                        var parentEntityID = Utils.IdBuilder.buildEntityID(dr.divID, dr.charTypeID, dr.recordID);
                        var childEntityID = Utils.IdBuilder.buildEntityID(dr.divID, dr.childCharTypeID, dr.childRecordID);
                        var desiredEntityID;

                        if (this.originalEntity.id == parentEntityID) {
                            //This is a child rel
                            desiredEntityID = childEntityID;
                        } else {
                            //This is a parent rel
                            desiredEntityID = parentEntityID;
                        }

                        this.entityService.getEntity(desiredEntityID)
                            .then((relatedEntity) => {
                                var charTypeName = relatedEntity.record.charTypeID.toString();
                                switch (relatedEntity.record.charTypeID) {
                                    case 1:
                                        charTypeName = "Catalog";
                                        break;
                                    case 2:
                                        charTypeName = "Contact";
                                        break;
                                    case 3:
                                        charTypeName = "Right";
                                        break;
                                    case 4:
                                        charTypeName = "Deals";
                                        break;
                                    case 5:
                                        charTypeName = "Usage";
                                        break;
                                    case 6:
                                        charTypeName = "Company";
                                        break;
                                    case 7:
                                        charTypeName = "Accounting";
                                        break;
                                    case 8:
                                        charTypeName = "Report";
                                        break;
                                    case 9:
                                        charTypeName = "Parameter";
                                        break;
                                    case 10:
                                        charTypeName = "Amount";
                                        break;
                                    case 11:
                                        charTypeName = "Period";
                                        break;
                                    case 12:
                                        charTypeName = "Date";
                                        break;
                                    case 13:
                                        charTypeName = "Royalty";
                                        break;
                                    case 14:
                                        charTypeName = "Document";
                                        break;
                                    case 15:
                                        charTypeName = "Job";
                                        break;
                                    case 16:
                                        charTypeName = "Project";
                                        break;
                                    case 17:
                                        charTypeName = "Inventory";
                                        break;
                                }

                                var relatedCharAndTemplate = charTypeName + ": " + relatedEntity.record.template;
                                relTemplates.push(relatedCharAndTemplate);
                            })
                            .finally(() => {
                                var distinctRelTemplates = _.sortBy(_.unique(relTemplates), (s) => s);

                                this.invalidAssociations = "";

                                _.forEach(distinctRelTemplates, (t) => {
                                    this.invalidAssociations += t + "; ";
                                });
                            });
                    }
                });
            });
    }

    Copy() {
        this.newTitle = this.newTitle.substr(0, this.maxTitleChars - 1);
        if (this.copyType == 2) {
            this.Migrate();
        } else {
            this.notifyService.startProgress();
            var newEntityID;

            if (this.originalEntity.charTypeID == Consts.CharTypeIDs.user) {
                this.copyParties = false;
            }

            var copyCharTypeID = this.originalEntity.charTypeID;
            var copyTemplateID = this.originalEntity.templateID;

            if (this.copyType == 3) {
                copyCharTypeID = this.selectedCopyToCharTypeID;
                copyTemplateID = this.selectedCopyToTemplateID;
            }

            if (_.any(this.moduleLevelCharTypeIDs, (id) => id == copyCharTypeID)) {
                var entityID = this.originalEntity.id;
                var notifyViaEmail: boolean = false;

                this.entityService.getEntityRelationships(entityID, -1)
                    .then((relResult) => {
                        if (relResult.length > 20) {
                            alert("We are copying your record. Once the copy process is done, we will notify you via email for next steps.");
                            notifyViaEmail = true;
                        }
                    })
                    .finally(() => {
                        this.notifyService.endProgress();
                        this.entityService.copyModuleLevelEntity(copyCharTypeID, copyTemplateID, this.copyRelationships, this.originalEntity.id, this.newTitle, this.copyParties, notifyViaEmail, this.selectAssociations)
                            .then((result) => {
                                this.notifyService.endProgress();
                                if (result) {
                                    var jobID = result.jobID;
                                    var jobTitle = result.jobTitle;
                                    var progressStatus: string = "";
                                    if (!notifyViaEmail) {
                                        this.modalService.jobProgress(jobID, jobTitle, progressStatus, false, false, true)
                                            .then((jobProgressResult) => {
                                                if (jobProgressResult.status == "Done") {
                                                    this.notifyService.notifySuccess("Copy succeeded");
                                                    var newEntityID = jobProgressResult.resultMessage;

                                                    //RL-6985 :- making sure to fire workflow action on create after copy
                                                    var splitEntityID = Utils.IdBuilder.splitEntityID(newEntityID);
                                                    this.workflowService.executeWorkflowActionAfterCopy(splitEntityID.divID, splitEntityID.charTypeID, splitEntityID.recID)
                                                        .then(() => {
                                                            if (this.selectAssociations) {
                                                                this.entityService.getEntityMigrateURL(this.originalEntity.charTypeID, newEntityID, copyTemplateID)
                                                                    .then((result) => {
                                                                        if (result.success) {
                                                                            this.notifyService.endProgress();
                                                                            var migrateUrl = result.data.replace("-1", this.originalEntity.recordID.toString());
                                                                            this.$window.location.assign(migrateUrl);
                                                                        }
                                                                        else {
                                                                            this.notifyService.notifyError("Migrate failed");
                                                                        }
                                                                    });
                                                            }
                                                            else {
                                                                this.successCallback({ newEntityID: newEntityID });
                                                            }
                                                        });
                                                }
                                            });
                                    }
                                }
                            });
                    });
            } else {
                this.entityService.copyComponentLevelEntity(copyCharTypeID, copyTemplateID, this.copyRelationships, this.originalEntity.id, this.newTitle, this.copyParties)
                    .then((result) => {
                        if (result.success) {
                            this.notifyService.notifySuccess("Copy succeeded");
                            newEntityID = result.entityID;
                            this.copyModalOpen = false;
                            this.successCallback({ newEntityID: newEntityID });
                        } else {
                            this.notifyService.notifyError("Copy failed");
                        }
                    }).finally(() => {
                        this.notifyService.endProgress();
                    });
            }
        }
    }

    Migrate() {
        this.notifyService.startProgress();
        let newCharTypeID = this.originalEntity.charTypeID;
        let newTemplateID = this.originalEntity.templateID;
        let isMigrate = this.copyType == 2;

        if (isMigrate) {
            newCharTypeID = this.selectedMigrateToCharTypeID;
            newTemplateID = this.selectedTemplateID;
        } else if (this.copyType == 3) {
            newCharTypeID = this.selectedCopyToCharTypeID;
            newTemplateID = this.selectedCopyToTemplateID;
        }

        if (isMigrate) {
            if (isMigrate && newCharTypeID == Consts.CharTypeIDs.user && this.originalEntity.charTypeID == Consts.CharTypeIDs.user) {
                // when migrating a user to another template, we need to keep the party associations that are still valid from a config perspective
                this.copyParties = true;
            }

            this.entityService.updateEntityTemplate(isMigrate, this.originalEntity.id, newCharTypeID, this.newTitle, newTemplateID, this.copyParties, this.selectAssociations)
                .then((result) => {
                    if (result.success) {
                        var newEntityID = result.data;
                        if (this.selectAssociations) {
                            //Bring the user to the Migrate Options Page
                            if (newEntityID == null) {
                                if (isMigrate) {
                                    this.notifyService.notifyError("Migrate failed");
                                } else {
                                    this.notifyService.notifyError("Copy failed");
                                }
                            } else {
                                this.entityService.getEntityMigrateURL(this.originalEntity.charTypeID, newEntityID, newTemplateID)
                                    .then((result) => {
                                        if (result.success) {
                                            this.notifyService.endProgress();

                                            var migrateUrl = result.data.replace("-1", this.originalEntity.recordID.toString());

                                            this.$window.location.assign(migrateUrl);
                                        } else {
                                            this.notifyService.notifyError("Migrate failed");
                                        }
                                    });
                            }
                        } else {
                            //View the entity with its new template
                            this.successCallback({ newEntityID: newEntityID });
                        }
                    } else {
                        this.notifyService.notifyError("Migrate failed");
                    }
                })
                .finally(() => {
                    this.copyModalOpen = false;
                    this.notifyService.endProgress();
                });
        } else {
            this.Copy();
        }
    }

    Cancel() {
        this.selectedCopyToCharTypeID = this.originalEntity.charTypeID;
        this.selectedMigrateToCharTypeID = this.originalEntity.charTypeID;
        this.selectedTemplateID = _.any(this.templates) ? this.templates[0].templateID : null;
        this.selectedCopyToTemplateID = _.any(this.copyToTemplates) ? this.copyToTemplates[0].templateID : null;
        this.copyType = 1;
        if (this.isOldVersion) {
            this.copyType = 3;
        }
        this.selectAssociations = false;
        this.invalidFields = "";
        this.invalidPartiesContacts = "";
        this.invalidAssociations = "";
        this.copyModalOpen = false;
    }
}
